//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbInfographicBox from '@/elements/editorial/cms-layout-variants-wrappers/rb-infographic-box/rb-infographic-box.vue'
import i18n from '@/scripts/libs/i18n'
import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-eyewear-protection-overlay-content',

  components: {
    RbInfographicBox,
  },

  computed: {
    copayLabel() {
      return this.$t('eyewear_protection.overlay.content.infographics.third.excerpts.second', {
        0: this.standardCopay,
      })
    },
    copayRoxLabel() {
      return this.$t('eyewear_protection.overlay.content.infographics.third.excerpts.third', {
        0: this.roxCopay,
      })
    },
    headerSubtitle() {
      return this.$t('eyewear_protection.overlay.header.subtitle', {
        0: this.standard,
        1: this.rox,
      })
    },
    standardLabel() {
      return this.$t('eyewear_protection.overlay.content.infographics.first.excerpts.second', {
        0: this.standard,
        1: this.rox,
      })
    },
    rox() {
      return this.isCanada ? '$69.99' : '$49.99'
    },
    roxCopay() {
      return this.isCanada ? '$129.99' : '$99.99'
    },
    standard() {
      return this.isCanada ? '$39.99' : '$29.99'
    },
    standardCopay() {
      return this.isCanada ? '$49.99' : '$39.99'
    },
    isCanada() {
      return wcs.isCanada()
    },
  },

  created() {
    i18n.loadTranslationsBySection('eyewear-protection')
  },
}
